(function () {
  function initVariantGallery() {
    // Root wrapper for this product's media
    const root = document.querySelector('.product__media-wrapper');
    if (!root) return;

    const defaultGallery = root.querySelector('.product-media-default');
    const variantGalleries = Array.from(
      root.querySelectorAll('.product-media-variant-galleries .variant-gallery')
    );

    if (!defaultGallery && !variantGalleries.length) return;

    function galleryHasImages(gal) {
      return !!(gal && gal.querySelector('img'));
    }

    function wireThumbs(gallery) {
      if (!gallery) return;

      // Prevent double-binding when switching variants back and forth
      if (gallery.dataset.thumbWired === 'true') return;
      gallery.dataset.thumbWired = 'true';

      const mainImg = gallery.querySelector('.variant-gallery__image-main');
      const thumbs = Array.from(gallery.querySelectorAll('.variant-gallery__thumb'));
      const prevBtn = gallery.querySelector('.variant-gallery__nav--prev');
      const nextBtn = gallery.querySelector('.variant-gallery__nav--next');

      if (!mainImg || !thumbs.length) return;

      let currentIndex = 0;

      function goToIndex(idx) {
        if (!thumbs.length) return;
        const total = thumbs.length;

        // wrap around
        if (idx < 0) idx = total - 1;
        if (idx >= total) idx = 0;

        const btn = thumbs[idx];
        const img = btn.querySelector('img');
        if (img && mainImg) {
          mainImg.src = img.src;
        }

        thumbs.forEach((t) => t.classList.remove('is-active'));
        btn.classList.add('is-active');

        currentIndex = idx;
        gallery.dataset.activeIndex = String(currentIndex);
      }

      // Initial active thumb (if any), otherwise 0
      thumbs.forEach((btn, index) => {
        if (btn.classList.contains('is-active')) {
          currentIndex = index;
        }

        btn.addEventListener('click', () => {
          goToIndex(index);
        });
      });

      // Make sure we sync the main image with the initial active thumb
      goToIndex(currentIndex);

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          goToIndex(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          goToIndex(currentIndex + 1);
        });
      }
    }

    function showForVariant(variantId) {
      let activeGallery = null;

      variantGalleries.forEach((gal) => {
        const isMatch =
          gal.dataset.variantId === String(variantId) && galleryHasImages(gal);

        if (isMatch) {
          gal.hidden = false;
          gal.style.display = '';
          activeGallery = gal;
        } else {
          gal.hidden = true;
          gal.style.display = 'none';
        }
      });

      // Only one gallery visible: default OR active variant gallery
      if (defaultGallery) {
        if (activeGallery) {
          defaultGallery.style.display = 'none';
        } else {
          defaultGallery.style.display = '';
        }
      }

      if (activeGallery) {
        wireThumbs(activeGallery);
      }
    }

    function getCurrentVariantId() {
      const idInput = document.querySelector(
        'form[data-type="add-to-cart-form"] input[name="id"]'
      );
      return idInput ? idInput.value : null;
    }

    // Initial load
    const initialVariantId = getCurrentVariantId();
    if (initialVariantId) {
      showForVariant(initialVariantId);
    }

    // Re-run when Shopify changes the hidden "id" input (variant change)
    document.addEventListener('change', () => {
      const currentId = getCurrentVariantId();
      if (currentId) {
        showForVariant(currentId);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initVariantGallery);
  document.addEventListener('shopify:section:load', initVariantGallery);
})();
